import cart from './cartReducer';
import header from './headerReducer';
import { currencyReducer } from './currencyReducer';

export default {
    cart,
    currency: currencyReducer,
    header,
};
